/**
 * Utility functions for date formatting
 */

/**
 * Format a date string to German locale with short month name (DD. MMM YYYY)
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date string or 'N/A' if invalid
 */
export const formatDate = (dateString) => {
	if (!dateString) return 'N/A';

	try {
		return new Date(dateString).toLocaleDateString('de-DE', {
			day: '2-digit',
			month: 'short',
			year: 'numeric',
		});
	} catch {
		return 'N/A';
	}
};

export const formatDateWithTime = (dateString) => {
	if (!dateString) return 'N/A';

	try {
		return new Date(dateString).toLocaleDateString('de-DE', {
			hour: '2-digit',
			minute: '2-digit',
			day: '2-digit',
			month: 'short',
			year: 'numeric',
		});
	} catch {
		return 'N/A';
	}
};

const RELATIVE_UNITS = [
	{ unit: 'minute', seconds: 60 },
	{ unit: 'hour', seconds: 3600 },
	{ unit: 'day', seconds: 86400 },
];

/**
 * "gerade eben", "vor 3 Min.", "vor 2 Std.", "vor 4 Tagen"; dates older than a week fall back to formatDate.
 * @param {string|Date} dateString
 * @returns {string}
 */
export const formatRelativeTime = (dateString) => {
	if (!dateString) return '';
	const elapsedSeconds = Math.round((Date.now() - new Date(dateString).getTime()) / 1000);
	if (!Number.isFinite(elapsedSeconds)) return '';
	if (elapsedSeconds < 60) return 'gerade eben';
	if (elapsedSeconds > 7 * 86400) return formatDate(dateString);
	const formatter = new Intl.RelativeTimeFormat('de-DE', { numeric: 'always', style: 'short' });
	const { unit, seconds } = [...RELATIVE_UNITS].reverse().find((entry) => elapsedSeconds >= entry.seconds);
	return formatter.format(-Math.round(elapsedSeconds / seconds), unit);
};
